import script from "./ClientMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientMenu.vue?vue&type=script&setup=true&lang=js"

import "./ClientMenu.vue?vue&type=style&index=0&id=647a115e&scoped=true&lang=css"
script.__scopeId = "data-v-647a115e"

export default script